import Wow from "wow.js";
import Swiper from "swiper";
const plg = require("../autoload/functions-comunes");
const plgForm = require("../autoload/functions-forms");
require("../autoload/plugins/chosen");

/**
 * [wow description]
 * @type {Wow}
 */
const wow = new Wow();
wow.init();


/**
 * [swiper description]
 * @type {Swiper}
 */
 if($(".swiper-container-generico").length>0){
  const swiper = new Swiper(".swiper-container-generico", {
    observer:true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    }
  });
  swiper.init();
 }

/**
 * [swiper description]
 * @type {Swiper}
 */
 if($(".swiper-container-sidebar").length>0){
  const swiper = new Swiper(".swiper-container-sidebar", {
    observer:true,
    autoHeight: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
  });
  swiper.init();
 }


/**
 * [chosen-select description]
 * @type {[type]}
 */
$(".chosen-select").chosen({
  disable_search_threshold: 10
});

/**
 * LISTENER menus con ancla
 * @param  {[type]} e){	e.preventDefault();	var ancla         [description]
 * @return {[type]}                              [description]
 */
$(".js-menu-ancla").click(function(e) {
  e.preventDefault();
  var ancla = $(this).attr("href");
  var offset = $(this).data("menuancla-offset");
  if (offset == "" || offset == undefined) {
    offset = 0;
  }
  plg.PLG_scrollTo(1, ancla, 0, offset, 0);
});

/**
 * LISTENER para mostrar modal alerta
 */
$(".js-modal-alerta").click(function(e) {
  e.preventDefault();
  plg.PLG_showModalAlerta(
    $(this).data("alerta-titulo"),
    $(this).data("alerta-texto")
  );
});

/**
 * LISTENER cierre cookies
 */
$("#modal-cookies .close").click(function() {
  $("#modal-cookies").fadeOut();
  plg.PLG_setCookie("accept.cookies", "true", 365);
});
plg.PLG_checkCookie();

/**
 * LISTENER copiar de un input
 */
$(".js-btn-copy").click(function() {
  var target = $(this).data("target-copy");
  plg.PLG_copyToClipboard(document.getElementById(target));
});


var lastScrollTop=0;
$(window).scroll(function(event) {
  var valorScroll=$(window).scrollTop();

  // añade clase "enpantalla" cuando aparece en pantalla
  $(".js-aparece-scroll").each(function(index, el) {
    if ($(this).offset().top+$(this).height()<=valorScroll+$(window).height()){
      $(this).addClass("enpantalla");
    }else{
      $(this).removeClass("enpantalla");
    }
  });

  //reducido cabecera
  var st = $(this).scrollTop();
  if (st > lastScrollTop && st>170){
    $("header").addClass('min');
  } else {
    $("header").removeClass('min');
  }
  lastScrollTop = st;
  

});


//cierra los menus de los hijos no seleccionados en sidebar-menu
  var items = $("#sidebar-menu .page_item");
  items.each(function(index){
    if(!$(this).hasClass("current_page_item")){
      $(this).find(".children").hide();
    }
  });

//*********
//gestión de envio de archivos en forms
//*********
var validado_contacto = true;
var msg_error = '';

//validamos el archivo a subir
jQuery(':file').on('change', function () {
  var file = this.files[0];
  
  var fileName = file.name;
  var extensiones = ["pdf","doc","docx","jpg","zip","rar","ppt","pptx","png","gif"];
  var lastDot = fileName.lastIndexOf('.');
  var ext = fileName.substring(lastDot + 1);
  //alert (ext);
  if (file.size > 2048000) {
    msg_error = 'El tamaño máximo del archivo es de 2MB';
    plg.PLG_showModalAlerta('Error',msg_error);
    validado_contacto = false;
  } else if (extensiones.includes(ext) == false ) {
    msg_error ='No se puede subir ese tipo de arhivo. Los tipos de archivo permitidos, son:<br>pdf, doc, docx, jpg,, png, gif, zip, rar, ppt, pptx';
    plg.PLG_showModalAlerta('Error',msg_error);
    validado_contacto = false;
    jQuery(':file').val('');
  } else {
    validado_contacto = true;
  }
});

//*********
// función para enviar forms por ajax. 
// en functions.php está la función que se ejecuta que tiene que venir como parámetro action en data
//*********
function enviar_form_ajax(que_form){

    if (validado_contacto) {
    
    //var todo = jQuery("#form-contacto").serialize();
    var todo = new FormData(jQuery(que_form)[0]);
      jQuery.ajax({ 
           data: todo,
           type: 'post',
           cache: false,
         contentType: false,
         processData: false,

           url: "/wp-admin/admin-ajax.php",
           success: function(data) {
              if (data.split(".")[0] == 'OK') {
                console.log(data); 
          //document.location.href='/';
          //alert ('Datos enviados con éxito. Este mensaje solo saldrá haciedo tests.');
          plg.PLG_showModalAlerta('Datos enviados con éxito','Sus datos se han enviado correctamente, nos pondremos en contacto con usted lo antes posible.<br>Gracias');
          jQuery(que_form)[0].reset();
              }
          }
      });
    } else {
      alert(msg_error);
    }

}

//*********
//gestión del formulario de contacto
//*********
jQuery('#form-contacto').submit(function(e){
  e.preventDefault();
  enviar_form_ajax('#form-contacto');
});

//*********
//gestión del formulario de directorio de empresas
//*********
jQuery('#form-directorio').submit(function(e){
  e.preventDefault();
  enviar_form_ajax('#form-directorio');
});

//*********
//gestión del formulario de alertas
//*********
jQuery('#form-alertas').submit(function(e){
  e.preventDefault();
  enviar_form_ajax('#form-alertas');
});

//*********
//gestión del formulario de bolsa de empleo
//*********
var validado_empleo = true;
var msg_error = '';

jQuery('#form-empleo').submit(function(e){
  e.preventDefault();
    if (validado_contacto) {
    
    //var todo = jQuery("#form-contacto").serialize();
    var todo = new FormData(jQuery("#form-empleo")[0]);
      jQuery.ajax({ 
           data: todo,
           type: 'post',
           cache: false,
           contentType: false,
           processData: false,

           url: "/wp-admin/admin-ajax.php",
           success: function(data) {
              if (data.split(".")[0] == 'OK') {
                console.log(data); 
          //document.location.href='/';
          //alert ('Datos enviados con éxito. Este mensaje solo saldrá haciedo tests.');
          plg.PLG_showModalAlerta('Datos enviados con éxito','Sus datos se han enviado correctamente, nos pondremos en contacto con usted lo antes posible.<br>Gracias');
          jQuery("#form-empleo")[0].reset();
              }
          }
      });
  } else {
    alert(msg_error);
  }
});

jQuery('#estudios').change(function(){
  if (this.value == 'otros') {
    jQuery('#otros_estudios').show();
  } else {
    jQuery('#otros_estudios').hide();
  }
});

jQuery('#desempleado_si').change(function(){
    jQuery('#datos-empresa').hide();
});

jQuery('#desempleado_no').change(function(){
    jQuery('#datos-empresa').show();
});


// WEBPACK FOOTER //
// ./scripts/autoload/functions-initlisteners.js